import React from 'react';
import './AppsPage.css';

const comingSoon = [
  { name: 'Contact', description: 'Share selected contact information.' },
  { name: 'Emergency', description: 'Carry important emergency information.' },
  { name: 'Here', description: 'Connect people and places through EveryID.' },
  { name: 'Groups', description: 'Private participation for families, teams and communities.' },
  { name: 'Agree', description: 'Simple acknowledgement and consent experiences.' }
];

export default function LegacyAppsContent() {
  const launchUrl =
    process.env.REACT_APP_OURMEMORIES_LAUNCH_URL ||
    'http://127.0.0.1:5173/auth/everyid/start';

  const launchOurMemories = () => {
    window.location.assign(launchUrl);
  };

  return (
    <main className="apps-page">
      <section className="apps-hero">
        <div className="apps-kicker">EVERYID APPS</div>
        <h1>One account. More ways to use it.</h1>
        <p>
          EveryID applications use your EveryID account while keeping each
          application's data and experience independent.
        </p>
      </section>

      <section className="apps-grid" aria-label="EveryID applications">
        <article className="app-card app-card-live">
          <div className="app-card-status">Available</div>
          <h2>OurMemories</h2>
          <p className="app-card-lead">
            Turn a photo, story and video into a memory someone can hold.
          </p>
          <button
            type="button"
            className="app-primary-button"
            onClick={launchOurMemories}
          >
            Create a Memory
          </button>
        </article>

        {comingSoon.map(app => (
          <article className="app-card" key={app.name}>
            <div className="app-card-status app-card-status-muted">
              Coming Soon
            </div>
            <h2>{app.name}</h2>
            <p>{app.description}</p>
            <button type="button" className="app-disabled-button" disabled>
              Coming Soon
            </button>
          </article>
        ))}
      </section>
    </main>
  );
}
